import React, { Component } from 'react'
import telTypes from '../../_constants/telTypes'
import Select from "react-select";

class TelTypeSelect extends React.Component {
  constructor(props) {
    super(props);

    const options = telTypes;
    let value = null;
    if (this.props.value) {
      value = options.filter(el => el.value === this.props.value)[0]
    }

    this.state = {
      select: {
        value: value, // initial value for react-select
        options // all available options
      }
    };
  }

  setValue = value => {
    this.setState(prevState => ({
      select: {
        ...prevState.select,
        value
      }
    }));
  };

  handleChange = value => {
    this.setValue(value);
    this.props.onChange(value.value);
  };

  handleClick = () => {
    this.setValue(null); // here we reset value
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== null) {
      if (nextProps.value !== this.state.value) {
        let value = this.state.select.options.filter(el => el.value === nextProps.value)[0]
        this.setValue(value)
      }
    } else {
      this.setValue(null)
    }
  }

  render() {

    const customStyles = {
      // option: (provided, state) => ({
      //   ...provided,
      //
      // }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        // height: 40,
        boxShadow: 'none',
        border: '1px solid #e1e1e1',
        paddingRight: '12',
        // boxShadow: '0 1px 8px rgba(0, 0, 0, 0.085)',
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading, select } = this.state;
    const { disabled, className } = this.props;

    return (
      <Select
        isClearable
        isDisabled={disabled}
        placeholder=""
        styles={customStyles}
        value={select.value}
        onChange={this.handleChange}
        options={select.options}
        isLoading={loading}
        className={className ? className : "select"}
        noOptionsMessage={() => "نتیجه ای یافت نشد"}
        loadingMessage={() => "در حال بارگزاری"}
      />
    )
  }
}

export default TelTypeSelect;